import React, { Component } from 'react';
import { Table, DatePicker, Button, Dropdown, message } from 'antd';
import { connect } from 'react-redux';
import _ from 'lodash';
import { logout, getAllUsers, downloadReportDetail, downloadUserData } from '../../user/action/user.actions'
import Header from "../../../layout/DefaultLayout/Header";
import '../../user/component/providerDeshbord.scss'
import { history } from '../../../helpers'
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import TableComponent from '../../user/component/dummyTable';
import moment from 'moment';

const items = [
  {
    label: 'Customer',
    key: 'C',
  },
  {
    label: 'Provider',
    key: 'P',
  },
];
export class AdminLayout extends Component {
  constructor(props) {
    super(props);
    this.state = {
      usersColumns: [
        {
          title: 'Booking Code',
          dataIndex: 'Booking Code',
          key: 'Booking Code',
        },
        {
          title: 'Booking Description',
          dataIndex: 'Booking Description',
          key: 'Booking Description',
        },
        {
          title: 'Booking Type',
          dataIndex: 'Booking Type',
          key: 'Booking Type',
        },
        {
          title: 'Model No',
          dataIndex: 'Model No',
          key: 'Model No',
        },
        {
          title: 'Product Name',
          dataIndex: 'Product Name',
          key: 'Product Name',
        },
        {
          title: 'Booking Time',
          dataIndex: 'Booking Time',
          key: 'Booking Time',
        },
        {
          title: 'Booking Date',
          dataIndex: 'Booking Date',
          key: 'Booking Date',
        },
        {
          title: 'Bidding Code',
          dataIndex: 'Bidding Code',
          key: 'Bidding Code',
        },
        {
          title: 'Bidding Date',
          dataIndex: 'Bidding Date',
          key: 'Bidding Date',
        },
        {
          title: 'Bidding Closing Date',
          dataIndex: 'Bidding Closing Date',
          key: 'Bidding Closing Date',
        },
        {
          title: 'Bidding Description',
          dataIndex: 'Bidding Description',
          key: 'Bidding Description',
        },
        {
          title: 'Total Amount',
          dataIndex: 'Total Amount',
          key: 'Total Amount',
        },
        {
          title: 'Provider Name',
          dataIndex: 'Provider Name',
          key: 'Provider Name',
        },
        {
          title: 'Provider Email',
          dataIndex: 'Provider Email',
          key: 'Provider Email',
        },
        {
          title: 'Provider Phone',
          dataIndex: 'Provider Phone',
          key: 'Provider Phone',
        },
        {
          title: 'Provider Code',
          dataIndex: 'Provider Code',
          key: 'Provider Code',
        },
        {
          title: 'Customer Name',
          dataIndex: 'Customer Name',
          key: 'Customer Name',
        },
        {
          title: 'Customer Email',
          dataIndex: 'Customer Email',
          key: 'Customer Email',
        },
        {
          title: 'Customer Phone',
          dataIndex: 'Customer Phone',
          key: 'Customer Phone',
        },
        {
          title: 'Customer Code',
          dataIndex: 'Customer Code',
          key: 'Customer Code',
        },
      ],
      data: [],
      start_date: '',
      end_date: '',
      booking_data: [],
      user_type: 'C'
    }
    this.logout = this.logout.bind(this);

  }
  componentDidMount() {
    this.getUsersData();
    this.getBookingData();
  }

  logout(e) {
    const { dispatch } = this.props;
    dispatch(logout())
  }

  getBookingData = () => {
    const { dispatch } = this.props;
    var endDateFormat = new Date()
    var endDate = `${endDateFormat.getFullYear()}-${endDateFormat.getMonth() + 1}-${endDateFormat.getDate()}`
    var startDateFormat = new Date()
    startDateFormat.setDate(startDateFormat.getDate() - 30);
    var startDate = `${startDateFormat.getFullYear()}-${startDateFormat.getMonth() + 1}-${startDateFormat.getDate()}`
    var data = {
      start_date: startDate,
      end_date: endDate
    }
    dispatch(downloadReportDetail(data)).then((response) => {
      let data = this.initializeDate(response.data)
      this.setState({ booking_data: data })
    })
  }

  getUsersData = () => {
    const { dispatch } = this.props;
    dispatch(getAllUsers()).then((response) => {
      this.setState({ data: response.data, originalData: response.data })
    })
  }



  initializeDate = (data) => {
    _.map(data, function (record) {
      record['Bidding Date'] = new Date(record['Bidding Date']).toLocaleString()
      record['Booking Date'] = new Date(record['Booking Date']).toLocaleString()
      record['Bidding Closing Date'] = new Date(record['Bidding Closing Date']).toLocaleString()
    })
    return data
  }

  downloadReport = () => {
    const { dispatch } = this.props;
    var startDateFormat = new Date(this.state.start_date)
    var startDate = `${startDateFormat.getFullYear()}-${startDateFormat.getMonth() + 1}-${startDateFormat.getDate()}`
    var endDateFormat = new Date(this.state.end_date)
    var endDate = `${endDateFormat.getFullYear()}-${endDateFormat.getMonth() + 1}-${endDateFormat.getDate()}`
    var data = {
      start_date: startDate,
      end_date: endDate
    }
    dispatch(downloadReportDetail(data)).then((response) => {
      let data = this.initializeDate(response.data)
      var dataDownload = data
      var fileName = "Reports"
      const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
      const fileExtension = '.xlsx';
      const ws = XLSX.utils.json_to_sheet(dataDownload);
      const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
      const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' })
      const dataDetail = new Blob([excelBuffer], { type: fileType });
      FileSaver.saveAs(dataDetail, fileName + fileExtension);
    })
  }

  downloadUserDetail = () => {
    const { dispatch } = this.props;
    if(this.state.start_date && this.state.end_date){
      var startDateFormat = new Date(this.state.start_date)
      var startDate = `${startDateFormat.getFullYear()}-${startDateFormat.getMonth() + 1}-${startDateFormat.getDate()}`
      var endDateFormat = new Date(this.state.end_date)
      var endDate = `${endDateFormat.getFullYear()}-${endDateFormat.getMonth() + 1}-${endDateFormat.getDate()}`
      var data = {
        user_type: "P",
        start_date: startDate,
        end_date: endDate
      }
      dispatch(downloadUserData(data)).then((response) => {
        var dataDownload = response.data
        var fileName = "Reports"
        const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
        const fileExtension = '.xlsx';
        const ws = XLSX.utils.json_to_sheet(dataDownload);
        const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
        const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' })
        const dataDetail = new Blob([excelBuffer], { type: fileType });
        FileSaver.saveAs(dataDetail, fileName + fileExtension);
      })
    }else{
      message.error('Please select the start date and end date');
    }
  }

  filterUserData = () => {
    if(this.state.start_date && this.state.end_date){
      let editData = [...this.state.originalData]
      var startDateFormat = new Date(this.state.start_date)
      var endDateFormat = new Date(this.state.end_date)
      editData = _.filter(editData, function(o) { return moment(o.created_at).isBetween(startDateFormat, endDateFormat) });
      this.setState({data: editData});
    }else{
      this.setState({data: this.state.originalData});
    }
  }

  handleDateChange = (name, value) => {
    if (name == 'start_date') {
      this.setState({ 'start_date': value });
    } else {
      this.setState({ 'end_date': value });
    }
  }

  render() {
    const { usersColumns, data, booking_data } = this.state
    return (
      <div>
        <Header></Header>
        <div className="services-background">
          <div className="biddings-container">
            <div className="service-heading-txt">Providers</div>
            {/* <div style={{ display: 'flex' }}>
              <Button className='btn-added-right' onClick={() => { this.downloadUserDetail() }}>
                Download User Data
              </Button>
            </div> */}
            <div className="row">
              <div className="col-4">
                <DatePicker
                  className='experience-date-picker-box'
                  placeholder="Start Date"
                  required
                  name="start_date"
                  value={this.state.start_date}
                  onChange={(e) => { this.handleDateChange('start_date', e) }}
                />
              </div>
              <div className="col-4">
                <DatePicker
                  className='experience-date-picker-box'
                  placeholder="End Date"
                  name="end_date"
                  value={this.state.end_date}
                  onChange={(e) => { this.handleDateChange('end_date', e) }}
                />
              </div>
              <div className="col-4">
                <Button className='btn-added-right' onClick={() => { this.downloadUserDetail() }}>
                    Download User Data
                </Button>
                <Button className='btn-added-right' onClick={() => { this.filterUserData() }}>
                    View Data
                </Button>
              </div>
            </div>
            <TableComponent columnsDetails={usersColumns} dataSource={data} type="P"/>
          </div>
        </div>
      </div >
    );
  }
}

function mapStateToProps(state) {
  const { user } = state.authentication;
  return {
    user
  }
}

export default connect(mapStateToProps)(AdminLayout);
